// import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Field, Label } from '@headlessui/react'
// import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import clsx from 'clsx'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'

type TRMDRComboBox = {

    name: string;
    title?: string;

    dataSource: any[];
    value?: any;

    displayExpr: string;
    searchExpr: string;
    idExpr: string;

    selectedIndex?: number;
    className?: string;
    selectClassName?: string;

    onClick: (name:string, value:any) => void,

}

const RMDRComboBox = (props: TRMDRComboBox) => {
    const { name, title, dataSource, value, displayExpr = "value", searchExpr = "name", idExpr = "id", selectedIndex, className, selectClassName, onClick } = props;

    const [selected, setSelected] = useState(undefined);

    useEffect(
        () => {
            if (selectedIndex !== null && selectedIndex !== undefined && selectedIndex >= 0) {
                setSelected(dataSource[selectedIndex]?.value);
            }
            if (!isEmpty(value)) {
                const _value = dataSource.find((item) => item[idExpr] === value);
                if (_value) setSelected(value)
            }
        }, [ selectedIndex, value ]
    )

    const _onChange = ( event:any ) => {
        setSelected(event.target.value);
        const _value = dataSource.find((item) => item[idExpr] === event.target.value);
        if ( onClick ) onClick(name, _value);
    }

    return (
        <div className={className}>
            {
                title && (<label>{title}</label>)
            }
            <select
                onChange={(e) => _onChange(e)}
                value={selected}
                name={name}
                className={selectClassName}
            >
                {
                    dataSource.map((item, index) => (<option value={item[idExpr]}>{item[displayExpr]}</option>))
                }
            </select>
        </div>
    );

    // return (
    //     <Field className={className}>
    //         {
    //             title && ( <Label className="ps-1 text-start w-100">{title}</Label> )
    //         }
    //         <Combobox value={selected} onChange={_onClick} onClose={() => setQuery('')}>
    //             <div className="tw-relative">
    //                 <ComboboxInput
    //                     className={clsx(
    //                         'tw-w-full tw-rounded-lg tw-border-none tw-py-1.5 tw-pr-8 tw-pl-3 tw-text-sm/6 tw-text-twine-400',
    //                         'focus:tw-outline-none data-[focus]:tw-outline-2 data-[focus]:-tw-outline-offset-2 data-[focus]:tw-outline-diSerria-400'
    //                     )}
    //                     displayValue={(item: any) => item?.[displayExpr]}
    //                     onChange={(event) => setQuery(event.target.value)}
    //                 />
    //                 <ComboboxButton className={clsx(
    //                     'tw-group tw-absolute tw-inset-y-1 tw-right-1 tw-outline-none tw-border-none tw-bg-white',
    //                 )}>
    //                     <ChevronDownIcon className="tw-size-4 tw-fill-twine-400" />
    //                 </ComboboxButton>
    //             </div>

    //             <ComboboxOptions
    //                 anchor="bottom"
    //                 transition
    //                 className={clsx(
    //                     'tw-w-[var(--input-width)] tw-rounded-xl tw-border tw-border-diSerria-400 tw-bg-white tw-p-1 [--anchor-gap:var(--spacing-1)] empty:tw-invisible',
    //                     'tw-transition tw-duration-100 tw-ease-in data-[leave]:data-[closed]:tw-opacity-0'
    //                 )}
    //             >
    //                 {filtered.map((item) => (
    //                     <ComboboxOption
    //                         key={item[idExpr]}
    //                         value={item}
    //                         className="tw-group tw-flex tw-cursor-default tw-items-center tw-gap-2 tw-rounded-lg tw-py-1.5 tw-px-3 tw-select-none data-[focus]:tw-bg-diSerria-400/10"
    //                     >
    //                         <div className="tw-text-sm/6 tw-text-twine-400">{item[displayExpr]}</div>
    //                     </ComboboxOption>
    //                 ))}
    //             </ComboboxOptions>
    //         </Combobox>
    //     </Field>
    // )
}

export default RMDRComboBox;